export const otpValidityTime = {
    min: 9,
    sec: 59,
};
export var loginScreenState;
(function (loginScreenState) {
    loginScreenState["LOGIN"] = "LOGIN";
    loginScreenState["PASSWORD"] = "PASSWORD";
    loginScreenState["OTP"] = "OTP";
    loginScreenState["CHOOSE_ACCOUNT"] = "CHOOSE_ACCOUNT";
    loginScreenState["FORGOT_LOGIN_ID"] = "FORGOT_LOGIN_ID";
    loginScreenState["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    loginScreenState["UNBLOCK_USER"] = "UNBLOCK_USER";
    loginScreenState["DEFAULT"] = "DEFAULT";
    loginScreenState["GUEST_LOGIN"] = "GUEST_LOGIN";
    loginScreenState["GUEST_LOGIN_MPIN"] = "GUEST_LOGIN_MPIN";
    loginScreenState["GUEST_LOGIN_TRIAL"] = "GUEST_LOGIN_TRIAL";
    loginScreenState["GUEST_REGISTER"] = "GUEST_REGISTER";
    loginScreenState["GUEST_VERIFY_MOBILE_OTP"] = "GUEST_VERIFY_MOBILE_OTP";
    loginScreenState["GUEST_VERIFY_EMAIL_OTP"] = "GUEST_VERIFY_EMAIL_OTP";
    loginScreenState["GUEST_SET_MPIN"] = "GUEST_SET_MPIN";
    loginScreenState["GUEST_EMAIL"] = "GUEST_EMAIL";
    loginScreenState["GUEST_FORGOT_MPIN"] = "GUEST_FORGOT_MPIN";
})(loginScreenState || (loginScreenState = {}));
export var forgotLoginIdState;
(function (forgotLoginIdState) {
    forgotLoginIdState["FORGOT_LOGIN_ID"] = "FORGOT_LOGIN_ID";
    forgotLoginIdState["SUCCESS_STATE"] = "SUCCESS_STATE";
})(forgotLoginIdState || (forgotLoginIdState = {}));
export var forgotPasswordState;
(function (forgotPasswordState) {
    forgotPasswordState["NEW_PASSWORD"] = "NEW_PASSWORD";
    forgotPasswordState["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    forgotPasswordState["SUCCESS_STATE"] = "SUCCESS_STATE";
})(forgotPasswordState || (forgotPasswordState = {}));
export var unblockUserState;
(function (unblockUserState) {
    unblockUserState["UNBLOCK_USER"] = "UNBLOCK_USER";
    unblockUserState["SUCCESS_STATE"] = "SUCCESS_STATE";
})(unblockUserState || (unblockUserState = {}));
export const handleNavigateUrl = (baseUrl, redirectQuery) => {
    if (redirectQuery) {
        return `${baseUrl}?redirectUrl=${encodeURIComponent(redirectQuery)}`;
    }
    else {
        return baseUrl;
    }
};
export var EAccountType;
(function (EAccountType) {
    EAccountType["CO"] = "CO";
    EAccountType["EQ"] = "EQ";
    EAccountType["COMEQ"] = "COMEQ";
})(EAccountType || (EAccountType = {}));
